import "babel-polyfill";
import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import { UIRouterReact } from '@uirouter/react';
import { createRouterMiddleware, routerReducer } from '@uirouter/redux';
import thunk from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react'
import storage from 'redux-persist/lib/storage';
import rootReducer from '../checkout/reducers/index';
import App from './App';
import InitRollbar from '@c/InitRollbar';
import reduxDevToolsComposeOptions from './helpers/reduxDevtoolsConfig';
import { getOrderTotal } from "../checkout/selectors/cart";
import { totalCostChange } from "../checkout/actions/ui";


InitRollbar();
const router = new UIRouterReact();
const routerMiddleware = createRouterMiddleware(router);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__(reduxDevToolsComposeOptions) : compose;

const compareTotalCost = (oldValue, newValue) =>
    JSON.stringify(oldValue) === JSON.stringify(newValue);

const dispatchTotalCostChangeMiddleware = getTotal => store => next => action => {
    const oldTotal = getTotal(store.getState());
    let result = next(action);
    const newTotal = getTotal(store.getState());
    if (!compareTotalCost(oldTotal, newTotal)) {
        store.dispatch(totalCostChange(oldTotal, newTotal));
    }

    return result;
};

// config for persisting reducer state -- storage is LocalStorage for web
const persistConfig = {
    key: 'root',
    storage: storage,
    // @todo -- evaluate whether ui state should be saved or if it might cause problems
    whitelist: ['member', 'delivery', 'coupon', 'ui', 'fees'] // only store member and delivery info in localstorage
};

// all of our reducers need to be wrapped by persistReducer even though we only actually persist based on the whitelist
const persistedReducer = persistReducer(persistConfig, combineReducers({
    ...rootReducer,
    router: routerReducer
}));

// create store as normal with persisted reducers
const store = createStore(
    persistedReducer,
    composeEnhancers(
        applyMiddleware(thunk, routerMiddleware, dispatchTotalCostChangeMiddleware(getOrderTotal))
    )
);

// persist the store
const persistor = persistStore(store);

// loading on the persist gate can be any component -- probably unnecessary for us
let renderWrapper = (rootElement, apiUrl, listingSlug, listingConfig = {}, listingData = {}, errorHandler) => {
    // php json encodes empty array to array instead of to object
    if(Array.isArray(listingConfig)) {
        listingConfig = {};
    }

    render(
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <App
                    router={router}
                    store={store}
                    apiUrl={apiUrl}
                    listingSlug={listingSlug}
                    listingConfig={listingConfig}
                    listingData={listingData}
                    errorHandler={errorHandler}
                />
            </PersistGate>
        </Provider>,
        rootElement
    )
}

export default renderWrapper;
